import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import PlayIcon from '../../atoms/play-icon';
import { BQLink } from '../../atoms/bqlink';
import { DATE_FORMATS } from '../../../constants';
import { convertToSlug, formatDate } from '../../../helpers/utils';
import AdWithPlaceholder from '../../molecules/ad-with-placeholder';
import { isMobile } from 'react-device-detect';

import './list-story.m.css';

const ListStory = ({
  story,
  fullWidthResult,
  hostImage,
  sectionHeading,
  showVideo,
  hideAuthor
}) => {
  const authorSlug = get(story, ['authors', '0', 'slug'], '')
    ? get(story, ['authors', '0', 'slug'], '')
    : convertToSlug(get(story, ['author-name']));
  const authorName = story ? (
    <div styleName="item__author">
      <span>
        <BQLink href={`/author/${story['author-id']}/${authorSlug}`} styleName="item__link">
          {story['author-name']}
        </BQLink>
      </span>
    </div>
  ) : null;
  const thumbnail =
    story && story['hero-image-s3-key']
      ? story['hero-image-s3-key']
      : 'bloombergquint/2016-04/24ae3b06-556b-478d-b06b-359236f251ac/top-noimage-ph-244b55b40c.jpeg?w=117&auto=format,compress';    // eslint-disable-line
  return story ? (
    <>
      <div styleName="results-list">
        <div
          styleName={`results-list__items ${
            fullWidthResult ? 'results-list__items-full-width' : ''
          }`}
        >
          <div key={story.id} styleName="item">
            <article>
              <div styleName="item__story-container">
                {showVideo ? (
                  <div styleName="item__image-container">
                    <BQLink story={story} href={`/${story.slug}`}>
                      <figure styleName="item__image-figure">
                        <img
                          src={`//${hostImage}/${thumbnail}`}
                          alt={story.headline}
                          styleName="item__image"
                        />
                        <span styleName="play-icon">
                          <PlayIcon width="45" height="45" />
                        </span>
                      </figure>
                    </BQLink>
                  </div>
                ) : null}
                <div styleName={` item__text-full-width ${showVideo ? 'item__text-wrapper' : ''}`}>
                  <div styleName="item__section">
                    <BQLink
                      href={`/${
                        get(story, ['sections', '0', 'slug'], '')
                          ? get(story, ['sections', '0', 'slug'], '')
                          : ''
                      }`}
                    >
                      {sectionHeading ||
                        (get(story, ['sections', '0', 'display-name'], '')
                          ? get(story, ['sections', '0', 'display-name'], '')
                          : get(story, ['sections', '0', 'name'], ''))}
                    </BQLink>
                  </div>
                  <h3 styleName="item__headline">
                    <BQLink story={story} href={`/${story.slug}`} styleName="item__link">
                      {story.headline}
                    </BQLink>
                  </h3>
                  {showVideo ? null : (
                    <h4 styleName="item__summary">
                      {story.subheadline ? story.subheadline : story.summary}
                    </h4>
                  )}
                  <div styleName="item__timestamp">
                    {hideAuthor || showVideo ? null : authorName}
                    <time dateTime="{story['last-published-at']}" styleName="updated-at">
                      <span styleName="updated-at__title">Updated on </span>
                      <span>
                        {formatDate(story['last-published-at'], DATE_FORMATS.DATE_TIME_INDIAN)}
                      </span>
                    </time>
                    <br />
                    <time dateTime="{story['published-at']}" styleName="published-at">
                      <span styleName="published-at__title">Published on </span>
                      <span>
                        {formatDate(story['first-published-at'], DATE_FORMATS.DATE_TIME_INDIAN)}
                      </span>
                    </time>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
      {story?.storyIndex === 10 && !isMobile && (
        <div className="responsive-ad desktop-only content-center" styleName="listingpagead">
          <AdWithPlaceholder adtype="SpListingBtwStories1" width="728px" height="90px" />
        </div>
      )}
      {story?.storyIndex === 7 && isMobile && (
        <div className="responsive-ad mobile-only content-center" styleName="listingpagead">
          <AdWithPlaceholder adtype="SpListingMrec2" width="300px" height="250px" />
        </div>
      )}
      {story?.storyIndex === 12 && isMobile && (
        <div className="responsive-ad mobile-only content-center " styleName="listingpagead">
          <AdWithPlaceholder adtype="SpListingBtwStories1Mob" width="320px" height="100px" />
        </div>
      )}
    </>
  ) : null;
};

ListStory.propTypes = {
  story: PropTypes.object,
  fullWidthResult: PropTypes.bool,
  hostImage: PropTypes.string,
  sectionHeading: PropTypes.string,
  showVideo: PropTypes.bool,
  hideAuthor: PropTypes.bool
};

export { ListStory };
